import utils from "../services/utils";
import {MODELS} from "../services/models";
import store from "../store";

const state = () => ({
  filters: {
    // Make sure to update resetFilters
    tasks: {
      users: [],
      temperatures: null,
      dealProbabilityScore: null,
      tag: 0,
      required: 0
    },
    appointments: {
      userAttendees: [],
    },
  },
  // orphanedRecords: [],
  pendingAppointments: [],
  incompleteTasks: [],
  requiredFilterEnum: {
    "NoFilter": {
      value: 0,
      label: "No Filter"
    },
    "No": {
      value: 1,
      label: "No"
    },
    "Yes": {
      value: 2,
      label: "Yes"
    }
  }
});

const getters = {
  // orphanedRecords(state) {
  //   return state.orphanedRecords;
  // },
  pendingAppointments(state) {
    let appointments = utils.clone(state.pendingAppointments);
    const filters = state.filters.appointments;

    return appointments.filter(appointment => {
      const apptUserAttendees = appointment.attendees.map(attendee => {
        if (attendee.class_name === MODELS.User.class_name) return attendee.id;
      });

      if (filters.userAttendees.length === 0) {
        return true;
      }

      if (filters.userAttendees.includes(0) && apptUserAttendees.length === 0) {
        return true;
      }

      return filters.userAttendees.some(filterAttendee=> apptUserAttendees.indexOf(filterAttendee) >= 0);
    }).sort((a, b) => new Date(a.start_at) - new Date(b.start_at));
  },
  incompleteTasks(state) {
    const filters = state.filters.tasks;

    return state.incompleteTasks
      .filter(task => {
        if (filters.users.length === 0) {
          return true;
        }

        if (filters.users.includes(0) && task.assigned_to_id == null) {
          return true;
        }

        return filters.users.includes(task.assigned_to_id);
      })
      .filter(task => {
        if (filters.temperatures === "" || filters.temperatures === null) {
          return true;
        }

        if (filters.temperatures === task.record.temperature || filters.temperatures === null) {
          return true;
        }
      })
      .filter(task => {
        if (filters.dealProbabilityScore === "" || filters.dealProbabilityScore === null) {
          return true;
        }

        if (filters.dealProbabilityScore === task.record.deal_probability_score) {
          return true;
        }
      })
      .filter(task => {
        if (filters.tag === 0 || filters.tag === null) {
          return true;
        }

        return task.tags.find(tag => tag.id === filters.tag);
      })
      .filter(task => {
        if (filters.required === state.requiredFilterEnum.NoFilter.value) {
          return true;
        }

        if (filters.required === state.requiredFilterEnum.No.value) {
          return !task.is_required_to_change_status;
        }

        if (filters.required === state.requiredFilterEnum.Yes.value) {
          return !!task.is_required_to_change_status;
        }
      });
  },
  incompleteTasksQueryFilter(state) {
    const required = `required=${state.filters.tasks.required}`
    const users = (state.filters.tasks.users.length) ? `&users=${state.filters.tasks.users.join(',')}` : ''
    const temperatures = (state.filters.tasks.temperatures !== null) ? `&temperatures=${state.filters.tasks.temperatures}` : ''
    const dealProbabilityScore = (state.filters.tasks.dealProbabilityScore !== null) ? `&dealProbabilityScore=${state.filters.tasks.dealProbabilityScore}` : ''
    const tag = (state.filters.tasks.tag !== 0) ? `&tag=${state.filters.tasks.tag}` : ''

    return `${required}${users}${temperatures}${dealProbabilityScore}${tag}`
  },
};

const mutations = {
  setOneFilter(state, [filterName, filter, value]) {
    state.filters[filterName][filter] = value;
    store.dispatch('updateUserAppFilter')
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    state.filters = filters
  },
  resetTasksFilters(state) {
    // Make sure to update state default
    state.filters.tasks = {
      users: [],
      temperatures: null,
      dealProbabilityScore: null,
      tag: 0,
      required: 0
    };

    store.dispatch('updateUserAppFilter')
  },
  resetAppointmentsFilters(state) {
    // Make sure to update state default
    state.filters.appointments = {
      userAttendees: [],
    };

    store.dispatch('updateUserAppFilter')
  },
};

const actions = {};

const UpNextStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default UpNextStore;
